import React from "react";
import { Box, Grid, Typography, Button, CardMedia } from "@mui/material";
import { useNavigate } from "react-router-dom"; 
import Image from "../Assets/AartiImage.png";

const HomePage = () => {
  const navigate = useNavigate(); 

  return (
    <Box
      sx={{
        minHeight: "85vh",
        mt: "10vh",
        display: "flex",
        alignItems: "center",
        justifyContent: { xs: "center", md: "flex-start" },
        px: { xs: 2, sm: 4, md: 0 },

        // ✅ 1024–1280px laptops
        "@media (min-width:1024px) and (max-width:1280px)": {
          mt: "15vh",
          alignItems: "center",
        },

        // ✅ 1281–1440px laptops
        "@media (min-width:1281px) and (max-width:1440px)": {
          mt: "14vh",
          alignItems: "center",
        },

        // ✅ Larger screens (1441px+)
        "@media (min-width:1441px)": {
          mt: "12vh",
          alignItems: "center",
        },
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent={{ xs: "center", md: "flex-start" }}
        sx={{
          height: "100%",
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        {/* LEFT CONTENT RECTANGLE */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            bgcolor: "#1E412D",
            color: "white",
            ml: { xs: 0, md: "100px" },
            px: { xs: "24px", sm: "40px", md: "80px" },
            py: { xs: 5, sm: 7, md: 10 },
            width: { xs: "100%", md: "calc(60% - 100px)" },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            borderRadius: { xs: 0, md: "0 12px 12px 0" },
            textAlign: { xs: "center", md: "left" },
            boxSizing: "border-box",

            // ✅ 1024–1280px
            "@media (min-width:1024px) and (max-width:1280px)": {
              ml: "50px",
              px: "50px",
              width: "calc(58% - 50px)",
              py: 7,
              minHeight: "70vh",
              justifyContent: "center",
            },

            // ✅ 1281–1440px
            "@media (min-width:1281px) and (max-width:1440px)": {
              ml: "60px",
              px: "70px",
              width: "calc(60% - 60px)",
              py: 8,
              minHeight: "75vh",
              justifyContent: "flex-start",
            },

            // ✅ 1441px+
            "@media (min-width:1441px)": {
              ml: "80px",
              px: "90px",
              width: "calc(55% - 80px)",
              py: 10,
              minHeight: "75vh",
              justifyContent: "center",
            },
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontFamily: "Playfair Display, serif",
              fontWeight: 700,
              mb: 3,
              color: "#F5EDE3",
              fontSize: {
                xs: "2rem",
                sm: "3.5rem",
                md: "4.2rem",
              },
              lineHeight: { xs: 1.2, sm: 1.3 },

              "@media (min-width:1024px) and (max-width:1280px)": {
                fontSize: "3.2rem",
              },
              "@media (min-width:1281px) and (max-width:1440px)": {
                fontSize: "4.5rem",
                mb: 4,
              },
              "@media (min-width:1441px)": {
                fontSize: "4.5rem",
                mb: 2,
              },
            }}
          >
            The Blush Story By <br /> AARTI SONI
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "#F5EDE3",
              fontFamily: "Lora, serif",
              lineHeight: 1.8,
              mb: 4,
              textAlign: "justify",
              fontSize: { xs: "0.9rem", sm: "1rem" },

              "@media (min-width:1024px) and (max-width:1280px)": {
                fontSize: "0.95rem",
              },
              "@media (min-width:1281px) and (max-width:1440px)": {
                fontSize: "1.5rem",
                mt: 5,
              },
              "@media (min-width:1441px)": {
                fontSize: "1.5rem",
                lineHeight: 1.8,
              },
            }}
          >
            <strong>"The Blush Story by Aarti Soni"</strong> is an elegant makeup
            startup, showcasing a blend of natural beauty and sophistication. The
            brand, led by <strong>Aarti Soni Dhanak</strong>, emphasizes personalized artistry with a
            focus on organic and luxurious makeup products. Its aesthetic is
            inspired by delicate floral themes and a rich green palette, creating
            a serene and creative vibe. This website aims to highlight Aarti's
            unique approach to makeup artistry.
          </Typography>

          {/* ✅ READ MORE button navigates to /about */}
          <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
            <Button
              variant="contained"
              onClick={() => navigate("/about-us")} 
              sx={{
                bgcolor: "#EBE4D4",
                color: "#003B1F",
                fontWeight: 600,
                fontFamily: "Lora, serif",
                px: { xs: 3, sm: 4 },
                py: 1.2,
                borderRadius: 2,
                transition: "background-color 0.3s, color 0.3s",
                "&:hover": {
                  bgcolor: "#003B1F",
                  color: "#EBE4D4",
                },

                "@media (min-width:1024px) and (max-width:1280px)": {
                  px: 3.5,
                  py: 1.1,
                },
                "@media (min-width:1281px) and (max-width:1440px)": {
                  px: 4,
                  py: 1.2,
                  fontSize: "1rem",
                  mt: 6,
                },
                "@media (min-width:1441px)": {
                  px: 5,
                  py: 1.4,
                  fontSize: "1rem",
                },
              }}
            >
              READ MORE
            </Button>
          </Box>
        </Grid>

        {/* RIGHT IMAGE SECTION (hidden on mobile/tablet) */}
        <Grid
          item
          md={6}
          sx={{
            display: { xs: "none", md: "flex" },
            justifyContent: "center",
            alignItems: "center",
            mb: { xs: 4, md: 0 },
            pr: { md: 0 },
            width: { xs: "100%", md: "50%" },

            "@media (min-width:1024px) and (max-width:1280px)": {
              width: "42%",
              pr: "20px",
            },
            "@media (min-width:1281px) and (max-width:1440px)": {
              width: "40%",
              pr: "30px",
            },
            "@media (min-width:1441px)": {
              width: "38%",
              pr: "60px",
            },
          }}
        >
          <Box
            sx={{
              borderRadius: "12px 0 0 12px",
              p: 4,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "80vh",

              "@media (min-width:1024px) and (max-width:1280px)": {
                height: "72vh",
              },
              "@media (min-width:1281px) and (max-width:1440px)": {
                height: "75vh",
              },
              "@media (min-width:1441px)": {
                height: "78vh",
              },
            }}
          >
            <CardMedia
              component="img"
              image={Image}
              alt="Aarti Soni (Owner)"
              sx={{
                width: "100%",
                height: "auto",
                objectFit: "contain",
                borderRadius: "12px",
                "@media (min-width:1024px) and (max-width:1280px)": {
                  maxHeight: "70vh",
                },
                "@media (min-width:1281px) and (max-width:1440px)": {
                  maxHeight: "75vh",
                },
                "@media (min-width:1441px)": {
                  maxHeight: "78vh",
                },
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HomePage;
